import React from 'react'

import PropTypes from 'prop-types'

import ItemsListingWrapper from 'Pods/ItemsListing/ItemsListingWrapper'
import i18n from 'Pods/Shared/I18n'
import Loader from 'Pods/Shared/Loader'

import ItemsSearchUrlBuilder from 'Utils/ItemsSearchUrlBuilder'

function UserCategory({ cart, userName, category, isDisplayedInCarouselle, locale }) {
  const getUrlParams = (categoryFilter) => {
    const urlBuilder = new ItemsSearchUrlBuilder()

    if (categoryFilter === 'print_ready') {
      urlBuilder.set({
        pathname: '/3d-print-models',
        search: '?',
      })
    } else {
      urlBuilder.set({
        pathname: '/3d-models',
        search: `?${categoryFilter}=1`,
      })
    }

    return urlBuilder.applyFilter('author', userName)
  }

  return category.items.length > 0 ? (
    <div className="user-models">
      <div className="user-models__header">
        <div className="user-models__left-section">
          <h2 className="user-models__heading heading-20">{category.title}</h2>
        </div>
        {category.items.length !== category.categoryCount && (
          <button
            type="button"
            className="btn btn-outline-default btn-white btn-dark"
            onClick={() => {
              window.open(
                getUrlParams(category.categoryFilter),
                '_blank',
                'noopener,noreferrer'
              )
            }}
          >
            {i18n.t('profilePage.viewAllModels', {
              ns: 'rails',
              lng: locale,
              modelCount: category.categoryCount,
            })}
          </button>
        )}
      </div>
      <ItemsListingWrapper
        perRowType="user"
        gaList="Profile Page"
        cart={cart}
        data={category.items}
        isWithCarousel={isDisplayedInCarouselle}
      />
    </div>
  ) : (
    <div className="user-models user-models--loading">
      <div className="user-models__header">
        <div className="user-models__left-section">
          <h2 className="user-models__heading heading-20">{category.title}</h2>
        </div>
      </div>
      <div className="user-models__loading">
        <Loader isFullHeight />
      </div>
    </div>
  )
}

UserCategory.propTypes = {
  cart: PropTypes.object.isRequired,
  userName: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  category: PropTypes.shape({
    items: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    categoryCount: PropTypes.number.isRequired,
    categoryFilter: PropTypes.string.isRequired,
  }).isRequired,
  isDisplayedInCarouselle: PropTypes.bool.isRequired,
}

export default UserCategory
